const required = "Dieses Feld ist erforderlich."
const invalid = "Ungültige Eingabe."

export function getRequiredFieldErrorId(value: string, name: string) {
  if (!value.trim()) {
    return required
  }
}

export function getEmailErrorId(value: string) {
  if (!value.trim()) {
    return required
  }
  if (!/.@./.test(value)) {
    return invalid
  }
}

export function getPhoneErrorId(value: string) {
  if (!value.trim()) {
    return required
  }
  if (!/[0-9 /\\()+-]+/.test(value)) {
    return invalid
  }
}
